export const ASSUME_ALL_BOARDS_ARE_GROUP_ART_TYPE = true;
